/* Ask Moira Beauty – right-side slide-out chat. No dependencies.
 *
 * Behavior: edge tab -> panel slides in from the right. UI inside mirrors the existing Moira chat widget.
 *  1. LIVE (moirabeauty.com): uses Shopify storefront endpoints (/collections/*.json, /search/suggest.json, /cart/add.js).
 *  2. BACKEND: set MoiraAskAgent.config.endpoint. Receives POST { messages:[{role,content}] },
 *     returns { reply, title?, products?:[{title,price,url,image,variantId}], followups?:[string] }.
 *  3. MOCK: used automatically off-site (e.g. preview.html).
 */
(function () {
  if (window.MoiraAskAgent) return;

  var config = {
    name: "Ask Moira Beauty",
    endpoint: null, // e.g. "/apps/moira-agent/chat"
    greetingTitle: "Hi! Ask Moira Beauty",
    greetingBody: "Hi! I'm your AI shopping assistant. Tell me what you're looking for like you would a store colleague \u2014 details like budget, occasion, color, style, and size are great. Or keep it simple and I'll guide you.",
    placeholder: "Ask Moira Beauty...",
    chips: [
      "What are some popular or featured products right now?",
      "Help me find a thoughtful gift.",
      "Show me items on sale or with the best prices.",
      "What are the best-selling items?",
      "What new arrivals are available?"
    ],
    bestSellerHandle: "best-seller",
    newHandle: "new-arrivals",
    giftHandle: "value-set",
    oilyHandle: "oil-control-collection",
    mock: !/moirabeauty\.com$/i.test(location.hostname) && !/\.myshopify\.com$/i.test(location.hostname)
  };

  var MOCK = [
    { title: "Maximum Volume & Lifting Mascara (002, Black)", price: "$7.00", url: "#", image: "", variantId: 1, hue: 340 },
    { title: "Glow Getter Hydrating Lip Oil (003, Rose)", price: "$9.00", url: "#", image: "", variantId: 2, hue: 20 },
    { title: "Soft Blush Balm", price: "$9.00", url: "#", image: "", variantId: 3, hue: 350 },
    { title: "Oil Control Foaming Cleanser", price: "$12.00", url: "#", image: "", variantId: 4, hue: 190 }
  ];

  var TITLES = { best: "Trending Bestsellers", oily: "Oil Control Picks", gift: "Gift Ideas", "new": "New Arrivals", search: "Top Matches" };
  var FOLLOWUPS = {
    best: ["Tell me about the lip oil", "Show eyeshadow palettes", "What's good for oily skin?"],
    oily: ["Show me the best sellers", "Recommend a gift set", "Show eyeshadow palettes"],
    gift: ["Show me the best sellers", "What's new?", "What's good for oily skin?"],
    "new": ["Show me the best sellers", "Help me find a gift", "What's good for oily skin?"],
    search: ["Add the first one to my cart", "Show me the best sellers", "What's good for oily skin?"]
  };

  var ICON = {
    spark: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M9 4l1.6 4.4L15 10l-4.4 1.6L9 16l-1.6-4.4L3 10l4.4-1.6L9 4z"/><path d="M18 3v4M16 5h4M18 15v4M16 17h4"/></svg>',
    cart: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><path d="M3 4h2.5l2.2 10.2a1.5 1.5 0 0 0 1.5 1.2h8.1a1.5 1.5 0 0 0 1.5-1.1L20.5 8H6.2"/><circle cx="9.5" cy="19.5" r="1.3"/><circle cx="17" cy="19.5" r="1.3"/></svg>',
    edit: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M12 5H6a2 2 0 0 0-2 2v11a2 2 0 0 0 2 2h11a2 2 0 0 0 2-2v-6"/><path d="M17.5 3.5a2 2 0 0 1 3 3L12 15l-4 1 1-4 8.5-8.5z"/></svg>',
    close: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><path d="M5 5l14 14M19 5L5 19"/></svg>',
    mic: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round"><path d="M4 11v2M8 8v8M12 5v14M16 9v6M20 11v2"/><path d="M19 3v3M17.5 4.5h3" stroke-width="1.6"/></svg>',
    send: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 19V5M5 12l7-7 7 7"/></svg>'
  };

  var root, els = {}, history = [], lastProducts = [], busy = false, cartCount = 0;

  function h(tag, cls, html) { var e = document.createElement(tag); if (cls) e.className = cls; if (html != null) e.innerHTML = html; return e; }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]; }); }
  function money(v) { var n = parseFloat(v); return isNaN(n) ? "" : "$" + n.toFixed(2); }
  function wait(ms) { return new Promise(function (r) { setTimeout(r, ms); }); }
  function json(url, opts) { return fetch(url, opts).then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); }); }

  /* ---------- UI ---------- */
  function build() {
    root = h("div", "maa-root");
    root.innerHTML =
      '<button class="maa-tab" aria-label="Open ' + esc(config.name) + '">' + ICON.spark + '</button>' +
      '<div class="maa-overlay"></div>' +
      '<aside class="maa-panel" role="dialog" aria-label="' + esc(config.name) + '" aria-hidden="true">' +
        '<div class="maa-head">' +
          '<div class="maa-brand">' + ICON.spark + '<span>' + esc(config.name) + '</span></div><span class="maa-beta">BETA</span>' +
          '<span class="maa-spacer"></span>' +
          '<a class="maa-cart" href="/cart" aria-label="View cart">' + ICON.cart + '<span class="maa-badge"></span></a>' +
          '<button class="maa-icon-btn maa-reset" aria-label="New chat">' + ICON.edit + '</button>' +
          '<button class="maa-icon-btn maa-close" aria-label="Close">' + ICON.close + '</button>' +
        '</div>' +
        '<div class="maa-scroll"><div class="maa-thread" aria-live="polite"></div></div>' +
        '<form class="maa-composer"><div class="maa-field">' +
          '<input type="text" placeholder="' + esc(config.placeholder) + '" aria-label="Message" autocomplete="off">' +
          '<button class="maa-mic" type="button" aria-label="Voice input">' + ICON.mic + '</button>' +
          '<button class="maa-send" type="submit" aria-label="Send">' + ICON.send + '</button>' +
        '</div></form>' +
        '<div class="maa-start-chips"></div>' +
      '</aside>';
    document.body.appendChild(root);

    els.tab = root.querySelector(".maa-tab");
    els.overlay = root.querySelector(".maa-overlay");
    els.panel = root.querySelector(".maa-panel");
    els.scroll = root.querySelector(".maa-scroll");
    els.thread = root.querySelector(".maa-thread");
    els.form = root.querySelector(".maa-composer");
    els.input = root.querySelector("input");
    els.send = root.querySelector(".maa-send");
    els.badge = root.querySelector(".maa-badge");
    els.startChips = root.querySelector(".maa-start-chips");

    els.tab.onclick = open;
    els.overlay.onclick = close;
    // dimmed area must not scroll the page (touch / wheel)
    els.overlay.addEventListener("wheel", function (e) { e.preventDefault(); }, { passive: false });
    els.overlay.addEventListener("touchmove", function (e) { e.preventDefault(); }, { passive: false });
    root.querySelector(".maa-close").onclick = close;
    root.querySelector(".maa-reset").onclick = reset;
    root.querySelector(".maa-mic").onclick = voice;
    els.input.oninput = function () { els.send.classList.toggle("ready", !!els.input.value.trim()); };
    els.form.onsubmit = function (e) { e.preventDefault(); var v = els.input.value.trim(); if (v) { els.input.value = ""; els.input.oninput(); ask(v); } };
    document.addEventListener("keydown", function (e) { if (e.key === "Escape") close(); });

    welcome();
    refreshCart();
  }

  function welcome() {
    els.panel.classList.add("maa-welcome-mode");
    els.startChips.innerHTML = "";
    els.thread.appendChild(h("div", "maa-hero", "<h2>" + esc(config.greetingTitle) + "</h2><p>" + esc(config.greetingBody) + "</p>"));
    addChips(config.chips, els.startChips);
  }

  // lock the page behind the panel (restores previous inline styles on close)
  var locked = null;
  function lockScroll() {
    if (locked) return;
    var de = document.documentElement, b = document.body, sw = window.innerWidth - de.clientWidth;
    locked = { h: de.style.overflow, b: b.style.overflow, p: b.style.paddingRight };
    de.style.overflow = "hidden"; b.style.overflow = "hidden";
    if (sw > 0) b.style.paddingRight = sw + "px"; // avoid layout jump when the scrollbar disappears
  }
  function unlockScroll() {
    if (!locked) return;
    document.documentElement.style.overflow = locked.h; document.body.style.overflow = locked.b; document.body.style.paddingRight = locked.p;
    locked = null;
  }

  function open() { lockScroll(); root.classList.add("maa-open"); els.panel.setAttribute("aria-hidden", "false"); refreshCart(); setTimeout(function () { els.input.focus(); }, 300); }
  function close() { unlockScroll(); root.classList.remove("maa-open"); els.panel.setAttribute("aria-hidden", "true"); els.tab.focus({ preventScroll: true }); }
  function reset() { history = []; lastProducts = []; els.thread.innerHTML = ""; welcome(); }
  function toBottom() { els.scroll.scrollTop = els.scroll.scrollHeight; }

  // optional voice input via the browser's Web Speech API (hidden failure if unsupported)
  function voice() {
    var SR = window.SpeechRecognition || window.webkitSpeechRecognition;
    if (!SR) return;
    var r = new SR(); r.lang = "en-US"; r.interimResults = false;
    r.onresult = function (e) { var t = e.results[0][0].transcript; if (t) ask(t); };
    try { r.start(); } catch (e) {}
  }

  function addMsg(role, text) { var m = h("div", "maa-msg " + role); m.textContent = text; els.thread.appendChild(m); toBottom(); return m; }
  function addTyping() { var m = h("div", "maa-msg bot", '<span class="maa-typing"><i></i><i></i><i></i></span>'); els.thread.appendChild(m); toBottom(); return m; }
  function clearChips() { Array.prototype.forEach.call(els.thread.querySelectorAll(".maa-chips"), function (n) { n.remove(); }); }

  function addChips(list, target) {
    if (!list || !list.length) return;
    var box = h("div", "maa-chips");
    list.forEach(function (t) {
      var b = h("button", "maa-chip"); b.type = "button"; b.textContent = t;
      b.onclick = function () { ask(t); };
      box.appendChild(b);
    });
    (target || els.thread).appendChild(box); toBottom();
  }

  function addProducts(list, title) {
    if (!list || !list.length) return;
    lastProducts = list;
    if (title) els.thread.appendChild(h("div", "maa-section-title", esc(title)));
    var row = h("div", "maa-products");
    list.forEach(function (p) {
      var hue = p.hue || 340;
      var img = p.image
        ? '<div class="img" style="background-image:url(\'' + esc(p.image) + '\')"></div>'
        : '<div class="img"><b style="background:linear-gradient(135deg,hsl(' + hue + ' 70% 85%),hsl(' + (hue + 30) + ' 65% 62%))"></b></div>';
      row.appendChild(h("a", "maa-card",
        img + '<div class="t">' + esc(p.title) + '</div><div class="p">' + esc(p.price || "") + '</div>'));
      row.lastChild.href = p.url || "#";
    });
    els.thread.appendChild(row); toBottom();
  }

  /* ---------- commerce ---------- */
  function setBadge(n) { cartCount = n; els.badge.textContent = n; els.badge.classList.toggle("on", n > 0); }
  function refreshCart() {
    if (config.mock) return;
    json("/cart.js").then(function (c) { setBadge(c.item_count || 0); }).catch(function () {});
  }

  function addToCart(p) {
    var done = function () {
      document.dispatchEvent(new CustomEvent("cart:refresh")); // many Shopify themes listen for this
      document.dispatchEvent(new CustomEvent("maa:cart-add", { detail: p }));
      refreshCart();
    };
    if (config.mock) { return wait(500).then(function () { setBadge(cartCount + 1); done(); }); }
    return json("/cart/add.js", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ items: [{ id: p.variantId, quantity: 1 }] }) }).then(done);
  }

  function fromProductJson(p) {
    var v = (p.variants && p.variants[0]) || {};
    return { title: p.title, price: money(v.price), url: "/products/" + p.handle, image: p.images && p.images[0] ? p.images[0].src : "", variantId: v.id };
  }
  function collection(handle, n) {
    return json("/collections/" + handle + "/products.json?limit=" + (n || 6)).then(function (d) { return d.products.map(fromProductJson); });
  }
  function search(q, n) {
    return json("/search/suggest.json?q=" + encodeURIComponent(q) + "&resources[type]=product&resources[limit]=" + (n || 6)).then(function (d) {
      return d.resources.results.products.map(function (p) { return { title: p.title, price: money(p.price), url: p.url, image: p.image, variantId: null, handle: p.handle }; });
    }).then(resolveVariants);
  }
  // suggest.json has no variant ids; fetch each product's JSON so add-to-cart works
  function resolveVariants(list) {
    return Promise.all(list.map(function (p) {
      return json("/products/" + p.handle + ".json").then(function (d) { return fromProductJson(d.product); }).catch(function () { return p; });
    }));
  }

  /* ---------- brain ---------- */
  function intent(q) {
    var s = q.toLowerCase();
    if (/add .*(cart|bag)|add (it|that|this|the first|them)|buy (it|that)/.test(s)) return "add";
    if (/best.?sell|popular|featured|top.?sell|favorite/.test(s)) return "best";
    if (/oily|oil control|shine|greasy/.test(s)) return "oily";
    if (/gift|present|birthday|holiday/.test(s)) return "gift";
    if (/new arrival|new |latest|just in|what's new/.test(s)) return "new";
    return "search";
  }

  var REPLIES = {
    best: "Here are some of our popular, best-selling products right now that shoppers are loving:",
    oily: "For oily skin, our Oil Control collection is a great place to start. It balances shine without drying you out:",
    gift: "These make easy, thoughtful gifts:",
    "new": "Here's what's new at Moira:",
    search: "Here's what I found for you:"
  };

  function respond(q) {
    var k = intent(q);
    if (k === "add") {
      var p = lastProducts[0];
      if (!p) return Promise.resolve({ reply: "Tell me what you're looking for first and I'll pull up some options to add.", followups: FOLLOWUPS.best });
      return addToCart(p).then(function () {
        return { reply: "Done! I added “" + p.title + "” to your cart. Anything else I can help you find?", followups: FOLLOWUPS.best };
      }).catch(function () { return { reply: "Sorry, I couldn't add that to your cart. Please try again." }; });
    }
    if (config.mock) {
      return wait(900).then(function () { return { reply: REPLIES[k], title: TITLES[k], products: MOCK, followups: FOLLOWUPS[k] }; });
    }
    var run = k === "best" ? collection(config.bestSellerHandle)
      : k === "new" ? collection(config.newHandle)
      : k === "gift" ? collection(config.giftHandle)
      : k === "oily" ? collection(config.oilyHandle)
      : search(q);
    return run.then(function (products) {
      if (!products.length) return { reply: "I couldn't find a match for that. Try describing the product, finish, or skin concern?", followups: FOLLOWUPS.best };
      return { reply: REPLIES[k], title: TITLES[k], products: products, followups: FOLLOWUPS[k] };
    }).catch(function () { return { reply: "Sorry, something went wrong on my end. Please try again." }; });
  }

  function callBackend() {
    return json(config.endpoint, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ messages: history }) });
  }

  function ask(q) {
    if (busy) return;
    busy = true; clearChips(); els.panel.classList.remove("maa-welcome-mode");
    var hero = els.thread.querySelector(".maa-hero"); if (hero) hero.remove();
    addMsg("user", q); history.push({ role: "user", content: q });
    var t = addTyping();
    var p = config.endpoint ? callBackend().catch(function () { return respond(q); }) : respond(q);
    p.then(function (r) {
      t.remove(); addMsg("bot", r.reply); history.push({ role: "assistant", content: r.reply });
      addProducts(r.products, r.title); addChips(r.followups);
    }).catch(function () { t.remove(); addMsg("bot", "Sorry, something went wrong. Please try again."); })
      .then(function () { busy = false; });
  }

  window.MoiraAskAgent = { config: config, open: open, close: close, init: function () { if (!root) build(); } };
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", window.MoiraAskAgent.init);
  else window.MoiraAskAgent.init();
})();